export default "\n# Install\n$ vue add electron-builder\n\n# Usage\n$ yarn electron:build\n$ yarn electron:serve\n";